/* Created by Interactive 63 - https://interactive63.com */
/**
 * Formatting and parsing of timeline times for the transport display.
 */

/** Formats milliseconds as m:ss.mmm, for example 1250 becomes "0:01.250". */
export function formatTime(ms: number): string {
  const total = Math.max(0, Math.round(ms));
  const minutes = Math.floor(total / 60000);
  const seconds = Math.floor((total % 60000) / 1000);
  const millis = total % 1000;
  return `${minutes}:${String(seconds).padStart(2, '0')}.${String(millis).padStart(3, '0')}`;
}

/**
 * Parses typed times: "1.25" or "1.25s" (seconds), "1250ms" and "0:01.25" (minutes and seconds).
 * Returns milliseconds, or null when the text is not a time.
 */
export function parseTime(text: string): number | null {
  const value = text.trim().toLowerCase();
  const millis = /^(\d+(?:\.\d+)?)\s*ms$/.exec(value);
  if (millis?.[1]) return Math.round(Number(millis[1]));
  const clock = /^(\d+):(\d{1,2}(?:\.\d+)?)$/.exec(value);
  if (clock?.[1] && clock[2]) return Math.round((Number(clock[1]) * 60 + Number(clock[2])) * 1000);
  const seconds = /^(\d+(?:\.\d+)?|\.\d+)\s*s?$/.exec(value);
  if (seconds?.[1]) return Math.round(Number(seconds[1]) * 1000);
  return null;
}
